"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeMetrics = void 0;
function TimeMetricsProd() {
    function doNothing() {
        return false;
    }
    return {
        startNewRun: doNothing,
        createBrowserPerformanceRun: doNothing,
        recordTimeStamp: doNothing,
        getReport: () => {
            return false;
        }
    };
}
function TimeMetricsLowerEnvironments(processName) {
    const timeRecord = {
        processName: processName || 'TMetrics',
        registered: new Date(),
        runs: []
    };
    let currentRun;
    function startNewRun(runName) {
        const dt = new Date();
        const run = {
            runName: runName || `Run ${dt.getTime()}`,
            registered: dt,
            reported: 0,
            timeStamps: []
        };
        timeRecord.runs.unshift(run);
        currentRun = run;
    }
    function recordTimeStamp(timeStampName, dateObj) {
        const dt = dateObj instanceof Date ? dateObj : new Date();
        if (timeRecord.runs.length === 0) {
            startNewRun();
        }
        currentRun.timeStamps.push({
            name: timeStampName || dt.toLocaleTimeString(),
            time: dt
        });
        return dt;
    }
    function getReport() {
        const runData = timeRecord.runs;
        const runs = runData.length;
        for (let r = 0; r < runs; r++) {
            const runRecord = runData[r];
            if (runRecord.reported === 0 || r === runs - 1) {
                processRun(runRecord);
            }
        }
        function processRun(runRecord) {
            const runStamps = runRecord.timeStamps;
            const stamps = runStamps.length;
            if (stamps > 1) {
                runStamps.sort((a, b) => a.time.getTime() - b.time.getTime());
                calculateMeasures(runStamps);
                runRecord.reported = 1;
            }
            function calculateMeasures(runStamps) {
                const tFirst = runStamps[0].time.getTime();
                const tLast = runStamps[stamps - 1].time.getTime();
                for (let s = 0; s < stamps; s++) {
                    const stamp = runStamps[s];
                    const stampTime = stamp.time.getTime();
                    const prevTime = runStamps[Math.max(0, s - 1)].time.getTime();
                    stamp.interval = miliToSecs(stampTime - prevTime);
                    stamp.accumulation = miliToSecs(stampTime - tFirst);
                    stamp.decumulation = miliToSecs(tLast - stampTime);
                }
            }
        }
        return timeRecord;
    }
    function createBrowserPerformanceRun(runName) {
        const pt = window.performance?.timing;
        if (!pt)
            return;
        startNewRun(runName || 'Initial Page Load Perf Timings');
        recordTimeStamp('navStart', new Date(pt.navigationStart));
        recordTimeStamp('reqStart', new Date(pt.requestStart));
        recordTimeStamp('respStart', new Date(pt.responseStart));
        recordTimeStamp('respEnd', new Date(pt.responseEnd));
        recordTimeStamp('domLoading', new Date(pt.domLoading));
        recordTimeStamp('domComplete', new Date(pt.domComplete));
        recordTimeStamp('loadEnd', new Date(pt.loadEventEnd));
    }
    function miliToSecs(miliSecs) {
        return (miliSecs / 1000).toFixed(3);
    }
    return {
        startNewRun,
        createBrowserPerformanceRun,
        recordTimeStamp,
        getReport
    };
}
const TimeMetrics = (processName) => {
    const LOCAL = /127\.0\.0\.1|localhost/;
    const isLocal = LOCAL.test(window.location.hostname);
    return isLocal ? TimeMetricsLowerEnvironments(processName) : TimeMetricsProd();
};
exports.TimeMetrics = TimeMetrics;
